import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSimpleSelectOptionMapper } from '../components';
import { masterDataSelector } from '../state';
import { Stores } from '../types';

const storesSort = (a: Stores, b: Stores) => (a.storeAcronym > b.storeAcronym ? 1 : -1);

const useStoreSelect = (countryCode: string, emptySelection: string | undefined = undefined) => {
  const masterData = useSelector(masterDataSelector);

  const storesForDivisonCountry = useMemo(() => {
    const stores = masterData.loaded && masterData.data ? masterData.data.stores : [];
    if (!countryCode) return [];
    return stores.filter(i => i.countryCode === countryCode).sort(storesSort);
  }, [masterData.data, masterData.loaded, countryCode]);
  const disabled = !countryCode;

  const mappedOptions = useSimpleSelectOptionMapper(
    storesForDivisonCountry || [],
    'storeAcronym',
    'storeAcronym'
  );
  const options = useMemo(() => {
    if (emptySelection !== undefined && mappedOptions.length && mappedOptions[0].id) {
      return [{ id: '', description: emptySelection }, ...mappedOptions];
    }
    return mappedOptions;
  }, [emptySelection, mappedOptions]);

  return { options, disabled, loading: masterData.loading };
};

export default useStoreSelect;
